import React, { useEffect, useState } from 'react';
import styles from './HowItWorksAdmin.module.css';
import Button from '../../ui/Button';
import { collection, query, orderBy, getDocs, addDoc, deleteDoc, updateDoc, doc } from 'firebase/firestore';
import { storage, firestore, auth }  from "../../../firebase/firebase.js";
import { useNotifications } from "../../../utils/NotificationContext/NotificationContext";
import LightNav from "./../LightNav/LightNav";
import { useAuth } from "../../../utils/AuthContext/authcontext";
import { Navigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';

export default function HowItWorksAdmin() {
  const [steps, setSteps] = useState([]);
  const { notify } = useNotifications();
  const { user, userData, claims } = useAuth(); 
  const { t } = useTranslation(); 
  
  const [form, setForm] = useState({
    title: '', description: '', iconName: '', order: 1
  });

  useEffect(() => {
    const fetchSteps = async () => {
      const q = query(collection(firestore, 'howItWorks'), orderBy('order'));
      const snap = await getDocs(q);
      setSteps(snap.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    fetchSteps();
  }, []);

  const handleChange = (field, value) => {
    setForm(prev => ({ ...prev, [field]: value }));
  };

  const handleAdd = async () => {
    try {
      await addDoc(collection(firestore, 'howItWorks'), {
        ...form,
        order: parseInt(form.order, 10)
      });
      notify('success', 'Step added!');
      setForm({ title: '', description: '', iconName: '', order: 1 });
    } catch (err) {
      notify('error', err.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(firestore, 'howItWorks', id));
      notify('success', 'Deleted');
    } catch (err) {
      notify('error', err.message);
    }
  };

  const handleUpdate = async (id, field, value) => {
    try {
      await updateDoc(doc(firestore, 'howItWorks', id), {
        [field]: field === 'order' ? parseInt(value, 10) : value
      });
      notify('success', 'Updated!');
    } catch (err) {
      notify('error', err.message);
    }
  };
  
  if (!user || claims?.role !== 'admin') {
    return <Navigate to="/home" />;
  }

  return (
	<>
    <LightNav/>
    <div className={styles.container}>
      <h2>{t('admin.howItWorksTitle')}</h2>

      <div className={styles.form}>
        <input placeholder="Title" value={form.title} onChange={e => handleChange('title', e.target.value)} />
        <input placeholder="Description" value={form.description} onChange={e => handleChange('description', e.target.value)} />
        <input placeholder="Heroicon Name" value={form.iconName} onChange={e => handleChange('iconName', e.target.value)} />
        <input placeholder="Order" type="number" value={form.order} onChange={e => handleChange('order', e.target.value)} />
        <Button variant="primary" onClick={handleAdd}>{t('admin.addStep')}</Button>
      </div>

      <ul className={styles.list}>
        {steps.map(step => (
          <li key={step.id}>
            <input
              value={step.title}
              onChange={e => handleUpdate(step.id, 'title', e.target.value)}
              placeholder="Title"
            />
            <input
              value={step.description}
              onChange={e => handleUpdate(step.id, 'description', e.target.value)}
              placeholder="Description"
            />
            <input
              value={step.iconName}
              onChange={e => handleUpdate(step.id, 'iconName', e.target.value)}
              placeholder="Heroicon"
            />
            <input
              value={step.order}
              type="number"
              onChange={e => handleUpdate(step.id, 'order', e.target.value)}
              placeholder="Order"
            />
            <Button variant="secondary" onClick={() => handleDelete(step.id)}>{t('admin.delete')}</Button>
          </li>
        ))}
      </ul>
    </div>
	</>
  );
}
